import React, { useState, useEffect } from 'react';
import './Header.css';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { FaChevronDown, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { FaPhone } from 'react-icons/fa';
import logoTransparent from '../Assets/LOGO-blanc.png';
import logoBlueBackground from '../Assets/saqr file 3.png';
import logoanimation from '../Assets/saqr file anime.png';

function Header({ isScrolled: propIsScrolled = false }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(propIsScrolled);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const isHomePage = location.pathname === '/';
  const isContactPage = location.pathname === '/contact';
  const isSolutionsPage = location.pathname === '/solutions';
  const isGestionBatimentsPage = location.pathname === '/solutions/gestion';
  const isIndustryAutoPage = location.pathname === '/solutions/Industry&auto';
  const issoftware = location.pathname === '/solutions/software';
  const ismaintennace = location.pathname === '/maintenance';
  const istraining = location.pathname === '/Formation';
  const isAboutus = location.pathname === '/aboutus';
  const istechnology = location.pathname === '/technology';
  const ispublicservice = location.pathname === '/Utilities';
  const isinfrastructure = location.pathname === '/Infrastructure';
  const isEnergy = location.pathname === '/energy';
  const isindustry = location.pathname === '/Industry';
  const isroutes = location.pathname === '/Routes&transports';
  const ispétrole = location.pathname === '/Pétrole';
  const isautomatique = location.pathname === '/Automatisation';
  const ismachineeng = location.pathname === '/machine-engineering';
  const isTransparentPage = isHomePage || isContactPage || isSolutionsPage || isGestionBatimentsPage || isIndustryAutoPage || issoftware || ismaintennace || istraining || isAboutus || istechnology || ispublicservice || isinfrastructure || isEnergy || isindustry || isroutes || ispétrole || isautomatique || ismachineeng;

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsScrolled(propIsScrolled);
  }, [propIsScrolled]);

  useEffect(() => {
    const detectDevTools = () => {
      const threshold = 100;
      if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
        setIsDevToolsOpen(true);
      } else {
        setIsDevToolsOpen(false);
      }
    };

    detectDevTools();
    window.addEventListener('resize', detectDevTools);
    return () => window.removeEventListener('resize', detectDevTools);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (isMobileMenuOpen) {
      setOpenDropdown(null);
    }
  };

  const handleNavClick = (path) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      navigate(path);
    }, 3000);
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
      setOpenDropdown(null);
    }
  };

  const handleServicesClick = (e) => {
    e.preventDefault();
    if (isHomePage) {
      const servicesSection = document.querySelector('.sevices');
      if (servicesSection) {
        servicesSection.scrollIntoView({ behavior: 'smooth' });
      }
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        setOpenDropdown(null);
      }
    } else {
      setIsLoading(true);
      navigate('/');
      setTimeout(() => {
        setIsLoading(false);
        const servicesSection = document.querySelector('.sevices');
        if (servicesSection) {
          servicesSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 3000);
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        setOpenDropdown(null);
      }
    }
  };

  const handleSolutionsClick = (e) => {
    e.preventDefault();
    if (isSolutionsPage) {
      const solutionsSection = document.querySelector('.solutions-container');
      if (solutionsSection) {
        solutionsSection.scrollIntoView({ behavior: 'smooth' });
      }
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        setOpenDropdown(null);
      }
    } else {
      setIsLoading(true);
      navigate('/solutions');
      setTimeout(() => {
        setIsLoading(false);
        const solutionsSection = document.querySelector('.solutions-container');
        if (solutionsSection) {
          solutionsSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 3000);
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        setOpenDropdown(null);
      }
    }
  };

  const handleFormationsClick = (e) => {
    e.preventDefault();
    if (istraining) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        setOpenDropdown(null);
      }
    } else {
      setIsLoading(true);
      navigate('/Formation');
      setTimeout(() => {
        setIsLoading(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 3000);
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        setOpenDropdown(null);
      }
    }
  };

  const handleFormationScroll = (e, id) => {
    e.preventDefault();
    if (istraining) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        element.classList.add('zoomed');
        setTimeout(() => element.classList.remove('zoomed'), 500);
      }
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        setOpenDropdown(null);
      }
    } else {
      setIsLoading(true);
      navigate('/Formation');
      setTimeout(() => {
        setIsLoading(false);
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          element.classList.add('zoomed');
          setTimeout(() => element.classList.remove('zoomed'), 500);
        }
      }, 3000);
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        setOpenDropdown(null);
      }
    }
  };

  const toggleDropdown = (dropdown) => {
    console.log('toggleDropdown:', dropdown, 'current openDropdown:', openDropdown);
    setOpenDropdown(prev => prev === dropdown ? null : dropdown);
  };

  const currentLogo = isTransparentPage && !isScrolled ? logoTransparent : logoBlueBackground;

  return (
    <>
      {isLoading && (
        <div className="loading-screen">
          <div className="loading-logo">
            <img src={logoanimation} alt="Segmic Engineering" />
          </div>
        </div>
      )}

      <header
        className={`header ${isTransparentPage && !isScrolled ? 'home-transparent' : 'scrolled'}`}
      >
        <div className="header-container">
          <div className="logo">
            <Link to="/" onClick={(e) => { e.preventDefault(); handleNavClick('/'); }}>
              <img src={currentLogo} alt="Segmic Engineering" style={{ width: isDevToolsOpen ? '50px' : 'auto' }} />
            </Link>
          </div>

          <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? <FiX size={40} /> : <FiMenu size={40} />}
          </button>

          <div className="twodiv">
            <div className="contact-info desktop-only">
              <div className="contact-item">
                <MdEmail size={16} className="contact-icon" />
                <a href="mailto:Info@saqrts.com">Info@saqrts.com</a>
              </div>
              <div className="contact-item">
                <FaPhone size={16} className="contact-icon" />
                <a href="tel:+213698909117">+213 557 11 11 17</a>
              </div>
              <div className="linkedin-whatsapp">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin size={20} className="social-icon" />
                </a>
                <a href="https://whatsapp.com" target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp size={20} className="social-icon" />
                </a>
              </div>
            </div>

            <nav className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
              <ul className="nav-list">
                <li className="nav-item">
                  <NavLink
                    to="/"
                    className="nav-link"
                    activeClassName="active"
                    onClick={(e) => { e.preventDefault(); handleNavClick('/'); }}
                  >
                    Accueil
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/aboutus"
                    className="nav-link"
                    activeClassName="active"
                    onClick={(e) => { e.preventDefault(); handleNavClick('/aboutus'); }}
                  >
                    À propos de Nous
                  </NavLink>
                </li>
                <li className="nav-item formations-item">
                  <div className="formations-toggle">
                    <div className="nav-link-wrapper">
                      <NavLink
                        to="/Formation"
                        className="nav-link"
                        activeClassName="active"
                        onClick={handleFormationsClick}
                      >
                        Formation
                      </NavLink>
                    </div>
                    <div className="dropdown-toggle">
                      <FaChevronDown
                        size={12}
                        className="dropdown-icon"
                        onClick={(e) => { e.stopPropagation(); toggleDropdown('formations'); }}
                      />
                    </div>
                    <ul className={`formations-window ${openDropdown === 'formations' ? 'mobile-active' : ''}`}>
                      <li className="formations-item">
                        <NavLink
                          to="/Formation#dynamic-balancing"
                          className="formations-link"
                          onClick={(e) => handleFormationScroll(e, 'dynamic-balancing')}
                        >
                          Dynamic Balancing
                        </NavLink>
                      </li>
                      <li className="formations-item">
                        <NavLink
                          to="/Formation#laser-alignment"
                          className="formations-link"
                          onClick={(e) => handleFormationScroll(e, 'laser-alignment')}
                        >
                          Laser Alignment
                        </NavLink>
                      </li>
                      <li className="formations-item">
                        <NavLink
                          to="/Formation#cat-i-vibration"
                          className="formations-link"
                          onClick={(e) => handleFormationScroll(e, 'cat-i-vibration')}
                        >
                          CAT I Vibration Analysis – Basic
                        </NavLink>
                      </li>
                      <li className="formations-item">
                        <NavLink
                          to="/Formation#cat-ii-vibration"
                          className="formations-link"
                          onClick={(e) => handleFormationScroll(e, 'cat-ii-vibration')}
                        >
                          CAT II Vibration Analysis – Intermediate
                        </NavLink>
                      </li>
                      <li className="formations-item">
                        <NavLink
                          to="/Formation#cat-iii-vibration"
                          className="formations-link"
                          onClick={(e) => handleFormationScroll(e, 'cat-iii-vibration')}
                        >
                          CAT III Vibration Analysis – Advanced
                        </NavLink>
                      </li>
                      <li className="formations-item">
                        <NavLink
                          to="/Formation#cat-iv-vibration"
                          className="formations-link"
                          onClick={(e) => handleFormationScroll(e, 'cat-iv-vibration')}
                        >
                          CAT IV Vibration Analysis – Expert
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item services-item">
                  <div className="services-toggle">
                    <div className="nav-link-wrapper">
                      <NavLink
                        to="/services"
                        className="nav-link"
                        activeClassName="active"
                        onClick={handleServicesClick}
                      >
                        Services
                      </NavLink>
                    </div>
                    <div className="dropdown-toggle">
                      <FaChevronDown
                        size={12}
                        className="dropdown-icon"
                        onClick={(e) => { e.stopPropagation(); toggleDropdown('services'); }}
                      />
                    </div>
                    <ul className={`services-window ${openDropdown === 'services' ? 'mobile-active' : ''}`}>
                      <li className="services-item">
                        <NavLink
                          to="/Maintenance"
                          className="services-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/Maintenance'); }}
                        >
                          Maintenance
                        </NavLink>
                      </li>
                      <li className="services-item">
                        <NavLink
                          to="/Analysevibratoire"
                          className="services-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/Analysevibratoire'); }}
                        >
                          Analyse Vibratoire
                        </NavLink>
                      </li>
                      <li className="services-item">
                        <NavLink
                          to="/machine-engineering"
                          className="services-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/machine-engineering'); }}
                        >
                          Machine Engineering
                        </NavLink>
                      </li>
                      <li className="services-item">
                        <NavLink
                          to="/industrial-engineering"
                          className="services-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/industrial-engineering'); }}
                        >
                          Industrial Engineering
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item solutions-item">
                  <div className="solutions-toggle">
                    <div className="nav-link-wrapper">
                      <NavLink
                        to="/solutions"
                        className="nav-link"
                        activeClassName="active"
                        onClick={handleSolutionsClick}
                      >
                        Solutions
                      </NavLink>
                    </div>
                    <div className="dropdown-toggle">
                      <FaChevronDown
                        size={12}
                        className="dropdown-icon"
                        onClick={(e) => { e.stopPropagation(); toggleDropdown('solutions'); }}
                      />
                    </div>
                    <ul className={`solutions-window ${openDropdown === 'solutions' ? 'mobile-active' : ''}`}>
                      <li className="solutions-item">
                        <NavLink
                          to="/solutions/analyse-vibratoire"
                          className="solutions-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/solutions/analyse-vibratoire'); }}
                        >
                          Analyse Vibratoire
                        </NavLink>
                      </li>
                      <li className="solutions-item">
                        <NavLink
                          to="/solutions/gestion"
                          className="solutions-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/solutions/gestion'); }}
                        >
                          Gestion intelligente des bâtiments
                        </NavLink>
                      </li>
                      <li className="solutions-item">
                        <NavLink
                          to="/solutions/gestion-lubrification"
                          className="solutions-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/solutions/gestion-lubrification'); }}
                        >
                          Gestion de la lubrification
                        </NavLink>
                      </li>
                      <li className="solutions-item">
                        <NavLink
                          to="/solutions/Industry&auto"
                          className="solutions-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/solutions/Industry&auto'); }}
                        >
                          Electricité industrielle & automatisme
                        </NavLink>
                      </li>
                      <li className="solutions-item">
                        <NavLink
                          to="/solutions/Monitoring"
                          className="solutions-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/solutions/Monitoring'); }}
                        >
                          Wireless Monitoring system
                        </NavLink>
                      </li>
                      <li className="solutions-item">
                        <NavLink
                          to="/solutions/software"
                          className="solutions-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/solutions/software'); }}
                        >
                          Software
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/contact"
                    className="nav-link"
                    activeClassName="active"
                    onClick={(e) => { e.preventDefault(); handleNavClick('/contact'); }}
                  >
                    Contact
                  </NavLink>
                </li>
                <li className="nav-item more-item desktop-only">
                  <div className="more-toggle">
                    <span className="nav-link">Plus</span>
                    <FaChevronDown size={12} className="more-icon" />
                    <ul className="more-window">
                      <li className="more-item">
                        <NavLink
                          to="/team"
                          className="more-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/team'); }}
                        >
                          Notre équipe
                        </NavLink>
                      </li>
                      <li className="more-item">
                        <NavLink
                          to="/projects"
                          className="more-link"
                          activeClassName="active"
                          onClick={(e) => { e.preventDefault(); handleNavClick('/projects'); }}
                        >
                          Projets
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item mobile-only">
                  <NavLink
                    to="/team"
                    className="nav-link"
                    activeClassName="active"
                    onClick={(e) => { e.preventDefault(); handleNavClick('/team'); }}
                  >
                    Team Page
                  </NavLink>
                </li>
                <li className="nav-item mobile-only">
                  <NavLink
                    to="/projects"
                    className="nav-link"
                    activeClassName="active"
                    onClick={(e) => { e.preventDefault(); handleNavClick('/projects'); }}
                  >
                    Project Page
                  </NavLink>
                </li>
                <li className="mobile-contact mobile-only">
                  <div className="contact-info">
                    <div className="contact-item">
                      <MdEmail size={18} className="contact-icon" />
                      <a href="mailto:segmic@segmic.com">Info@saqrts.com</a>
                    </div>
                    <div className="contact-item">
                      <FaPhone size={18} className="contact-icon" />
                      <a href="tel:+213557111117">+213557111117</a>
                    </div>
                    <div className="linkedin-whatsapp">
                      <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                        <FaLinkedin size={20} className="social-icon" />
                      </a>
                      <a href="https://whatsapp.com" target="_blank" rel="noopener noreferrer">
                        <FaWhatsapp size={20} className="social-icon" />
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;